export let SignupPlan = /*#__PURE__*/function (SignupPlan) {
  SignupPlan["ESSENTIAL"] = "essential";
  SignupPlan["STANDARD"] = "standard";
  SignupPlan["AGENCY_ESSENTIAL"] = "agency_essential";
  SignupPlan["AGENCY_STANDARD"] = "agency_standard";
  return SignupPlan;
}({});
export let SignupCurrency = /*#__PURE__*/function (SignupCurrency) {
  SignupCurrency["EUR"] = "eur";
  SignupCurrency["USD"] = "usd";
  return SignupCurrency;
}({});